import { render, staticRenderFns } from "./RegulationsOverviewPage.vue?vue&type=template&id=bfe58b08&"
import script from "./RegulationsOverviewPage.vue?vue&type=script&lang=js&"
export * from "./RegulationsOverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./RegulationsOverviewPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports